/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import ExtraServices from "reusables/sections/ExtraServices";

function PostConstruction_Section3() {
  return (
    <Container>
      <ExtraServices
        description="For more specialized requirements, we offer:"
        services={[
          "Exterior window cleaning",
          "Deep carpet and upholstery cleaning",
          "Pressure washing for outdoor areas",
        ]}
      />
    </Container>
  );
}

export default PostConstruction_Section3;
